import React from 'react';
import { Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import Strips from '../Strips';

const mobileFooterStyles = makeStyles({
  footer: {
    backgroundColor: '#0086ff',
    position: 'sticky',
    top: '0',
    padding: '5px 12px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '15px',
    '& a': {
      textDecoration: 'none',
      color: '#fff',
    },
  },
  content: {
    color: 'white',
    fontSize: '12px',
    textAlign: 'center',
  },
});

export default function MobileFooter() {
  const classes = mobileFooterStyles();

  return (
    <>
      <Strips />
      <footer className={classes.footer}>
        <div className={classes.wrapper}>
          <div className={classes.content}>
            <Typography>
              Preços e condições de pagamento exclusivos para compras via
              internet e podem variar nas lojas físicas. Ofertas válidas até o
              término de nossos estoques para internet. Vendas sujeitas à
              análise e confirmação de dados.
            </Typography>
            <br />
            <br />
            <Typography>
              Rodovia dos Bandeirantes KM 68,760 - Rio Abaixo
              <br />
              CEP: 13213-902 - Louveira/SP
              <br />
              CNPJ: 47960950/0449-27
              <br />
              Endereço para correspondência: Rua do Comércio, 1924 - Rio Abaixo
              - CEP: 14400-660 - Franca/SP
              <br />
              <Link href="https://www.magazineluiza.com.br/formulariocontato">
                www.magazineluiza.com.br/formulariocontato
              </Link>
              <br />® Magazine Luiza – Todos os direitos reservados
            </Typography>
          </div>
        </div>
      </footer>
    </>
  );
}
